export default __webpack_public_path__ + "static/media/close-quiz.e3e732d7.svg";